import { defineMessages } from 'react-intl-next';

export const i18n = defineMessages({
	positionStatusFilterLabel: {
		id: 'search-page.filters.names.position-status-filter',
		defaultMessage: 'Filled status',
		description: 'Label for filtering by position status',
	},
	positionStatusFilterPlaceholder: {
		id: 'search-page.talent.filter.position-status-filter.content.placeholder',
		defaultMessage: 'Find filled status',
		description: 'Placeholder for position status filter search input',
	},
	positionStatusFilterLabelSelected: {
		id: 'search-page.talent.filter.position-status-filter.content.selected',
		defaultMessage: 'Selected',
		description: 'Position status filter content selected',
	},
	positionStatusFilterLabelUnselected: {
		id: 'search-page.talent.filter.position-status-filter.content.unselected',
		defaultMessage: 'Suggested',
		description: 'Position status filter content unselected',
	},
});
